import './Technology.css';

function AboutTechnology() {
  const techList = [
    {
      image: '/images/cer01.png',
      title: '초기우수처리시스템 특허',
      detail: <>빗물재활용에 필요한 기구설계<br />빗물감지 센서기술<br />우수처리제어 시스템기술<br />(건축설비)</>
    },
    {
        image: '/images/cer02.png',
        title: '동파방지제어시스템 특허',
        detail: <>동파방지 정온전선제어 기술<br />초소형, 무접점 히터전원제어 기술<br />(건축설비)</>
    },
    {
      image: '/images/cer03.png',
      title: '재봉기 밑실 끝단 감지장치 특허',
      detail: <>광학 및 서보기술을 사용한 변화량 측정기술<br />(섬유/자동차내장재)</>
    },
    {
      image: '/images/cer04.png',
      title: '다중모터 배연창제어 특허',
      detail: <>배연창 개폐 기술<br />다중모터의 균일한 이송 기술<br />(창호/소방)</>
    },
      
    {
      image: '/images/PSI5_logo.png',
      title: 'PSI5 롬라이팅',
      detail: <>PSI5 Interface 통신 기술<br />(자동차센서)</>
    }
  ];

  return (
    <div className="overview-container">
      <div className="heat-section-title">보유기술</div>
      <div className="tech-list">
        {techList.map((item, index) => (
          <div key={index} className="tech-row">
            <div className="tech-image">
              <img src={item.image} alt={item.title} />
            </div>
            <div className="tech-content">
              <div className="tech-title">{item.title}</div>
              <div className="tech-detail">{item.detail}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AboutTechnology;
